(() => {
  /* eslint no-bitwise: ["error", { "allow": ["^", ">>"] }] */
  const generateUUID = (n) => (n
    ? (n ^ ((16 * Math.random()) >> (n / 4))).toString(16)
    : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, generateUUID));
  document
    .querySelector('#refinements-clear')
    .addEventListener('click', (e) => {
      window.tagular('beam', 'ElementClicked', {
        '@type': 'redventures.usertracking.v3.ElementClicked',
        webElement: {
          elementType: 'filter-reset',
          text: e.target.textContent,
          location: 'below-filters',
          htmlId: 'clear-all-filters',
          name: 'clear-filters',
        },
        correlationId: generateUUID(),
      });
    });

  const formContext = {
    formType: 'filter',
    formName: 'school-profile-hub',
    formVersion: '1.0',
    formId: '1000',
  };

  // adds tracking to seach bar
  document.querySelector('.ais-SearchBox-input').onchange = (e) => {
    window.tagular('beam', 'FieldInputted', {
      '@type': 'redventures.usertracking.v3.FieldInputted',
      userInputField: {
        autofilled: false,
        fieldName: 'search-box',
        fieldLabel: 'Search',
        fieldValue: e.target.value,
      },
      formContext,
      correlationId: generateUUID(),
    });
  };
  // adds tracking to State checkboxes
  document
    .querySelectorAll('.school-profiles__filters__refinement-state')
    .forEach((listItem) => {
      listItem.addEventListener('click', (e) => {
        window.tagular('beam', 'FieldSelected', {
          '@type': 'redventures.usertracking.v3.FieldSelected',
          userInputField: {
            autofilled: false,
            fieldName: 'state',
            fieldLabel: 'State',
            fieldValue: e.target.value.replace(/\s+/g, '-').toLowerCase(),
          },
          formContext,
          correlationId: generateUUID(),
        });
      });
    });

  // adds tracking to School Type toggles
  document
    .querySelectorAll('.refinement-list-school-type')
    .forEach((listItem) => {
      listItem.addEventListener('change', (e) => {
        window.tagular('beam', 'FieldSelected', {
          '@type': 'redventures.usertracking.v3.FieldSelected',
          userInputField: {
            autofilled: false,
            fieldName: 'school-type',
            fieldLabel: 'School Type',
            fieldValue: e.target.labels[0].innerText.toLowerCase(),
          },
          formContext,
          correlationId: generateUUID(),
        });
      });
    });
  // adds tracking to Learning Format toggles
  document
    .querySelectorAll('.refinement-list-learning-format')
    .forEach((listItem) => {
      listItem.addEventListener('change', (e) => {
        window.tagular('beam', 'FieldSelected', {
          '@type': 'redventures.usertracking.v3.FieldSelected',
          userInputField: {
            autofilled: false,
            fieldName: 'learning-format',
            fieldLabel: 'Learning Format',
            fieldValue: e.target.labels[0].innerText.toLowerCase(),
          },
          formContext,
          correlationId: generateUUID(),
        });
      });
    });
})();
